const CHECK_MARK = "ok";
const CROSS = "x";
const SEARCHES_MONTH_250 = { number: 250, normal: "searches/month" };
const SEARCHES_MONTH_500 = { number: 500, normal: "searches/month" };
const SEARCHES_MONTH_1000 = { number: 1000, normal: "searches/month" };
const SEARCHES_MONTH_1500 = { number: 1500, normal: "searches/month" };
const SEARCHES_MONTH_2000 = { number: 2000, normal: "searches/month" };
const SEARCHES_MONTH_3000 = { number: 3000, normal: "searches/month" };
const PRODUCTS_50 = { number: 50, normal: "products" };
const PRODUCTS_100 = { number: 100, normal: "products" };
// const PRODUCTS_150 = { number: 150, normal: "products" };
const KEYWORDS_500 = { number: 500, normal: "keywords" };
const KEYWORDS_1500 = { number: 1500, normal: "keywords" };
// const KEYWORDS_2500 = { number: 2500, normal: "keywords" };

const PRODUCT_RESEARCH_TOOLS = {
  title: "Product Research Tools",
  tab: [
    {
      title: {
        text: "PRO AI Extension",
        tooltip: "Find and verify profitable products using AI, and see if they are trending upward or downward. Check competition levels, discover sourcing options, and improve the quality of your listing.",
        mark: CHECK_MARK
      },
      tariffs: {
        mark: CHECK_MARK
      }
    },
    {
      title: {
        text: "AI Niche Analysis",
        complexTooltip: true,
        mark: CHECK_MARK
      },
      tariffs: {
        mark: CHECK_MARK
      }
    },
    {
      title: {
        text: "Product Database",
        tooltip: "Generate profitable product ideas, select the best product from a profitable niche, and check product performance.",
        mark: CHECK_MARK,
        info: {
          monthly: SEARCHES_MONTH_1000,
          monthly_3: SEARCHES_MONTH_1000,
          yearly: SEARCHES_MONTH_2000
          // lifetime: SEARCHES_MONTH_3000
        }
      },
      tariffs: {
        info: {
          monthly: SEARCHES_MONTH_1000,
          monthly_3: SEARCHES_MONTH_1000,
          yearly: SEARCHES_MONTH_2000
          // lifetime: SEARCHES_MONTH_3000
        }
      }
    },
    {
      title: {
        text: "Product Tracker",
        tooltip: "Track each product’s daily sales and rating changes. Keep an eye on competing products and confirm viability before committing to selling.",
        mark: CHECK_MARK,
        info: {
          monthly: PRODUCTS_50,
          monthly_3: PRODUCTS_50,
          yearly: PRODUCTS_100
          // lifetime: PRODUCTS_150
        }
      },
      tariffs: {
        info: {
          monthly: PRODUCTS_50,
          monthly_3: PRODUCTS_50,
          yearly: PRODUCTS_100
          // lifetime: PRODUCTS_150
        }
      }
    }
  ]
};
const KEYWORD_RESEARCH_TOOLS = {
  title: "Keyword Research Tools",
  tab: [
    {
      title: {
        text: "Amazon Keyword Search & Product Keywords Lookup 2.0",
        complexTooltip: true,
        mark: CHECK_MARK,
        info: {
          monthly: SEARCHES_MONTH_1500,
          monthly_3: SEARCHES_MONTH_1500,
          yearly: SEARCHES_MONTH_3000
          // lifetime: SEARCHES_MONTH_3000
        }
      },
      tariffs: {
        info: {
          monthly: SEARCHES_MONTH_1500,
          monthly_3: SEARCHES_MONTH_1500,
          yearly: SEARCHES_MONTH_3000
          // lifetime: SEARCHES_MONTH_3000
        }
      }
    },
    {
      title: {
        text: "Trending Keywords",
        complexTooltip: true,
        mark: CHECK_MARK
      },
      tariffs: {
        mark: CHECK_MARK
      }
    },
    {
      title: {
        text: "Keyword Tracker",
        tooltip: "Make sure that your product’s keywords are indexed by Amazon, and track their organic search ranking to bring in more buyers on the same PPC ads budget.",
        mark: CHECK_MARK,
        info: {
          monthly: KEYWORDS_500,
          monthly_3: KEYWORDS_500,
          yearly: KEYWORDS_1500
          // lifetime: KEYWORDS_2500
        }
      },
      tariffs: {
        info: {
          monthly: KEYWORDS_500,
          monthly_3: KEYWORDS_500,
          yearly: KEYWORDS_1500
          // lifetime: KEYWORDS_2500
        }
      }
    }
  ]
};
const TRENDS_AND_PRODUCT_IDEAS_BUNDLE = {
  title: "Trends & Product Ideas",
  tab: [
    {
      title: {
        text: "Monthly Trend Reports",
        tooltip: "Receive reports that include monthly product trends, profitable niches, Amazon news, insights, and tips for maximizing your profits.",
        mark: CHECK_MARK
      },
      tariffs: {
        mark: CHECK_MARK
      }
    },
    {
      title: {
        text: "1,000+ Exclusive Amazon Products",
        tooltip: "Receive 19 of the top 1% profitable products delivered to you weekly. Each one is selected from over 600 million products by AI.",
        mark: {
          monthly: CROSS,
          monthly_3: CROSS,
          yearly: CHECK_MARK
          // lifetime: CHECK_MARK
        }
      },
      tariffs: {
        mark: {
          monthly: CROSS,
          monthly_3: CROSS,
          yearly: CHECK_MARK
          // lifetime: CHECK_MARK
        }
      }
    }
  ]
};
const LEARNING = {
  title: "Learning",
  tab: [
    {
      title: {
        text: "AMZScout Seller's Courses",
        tooltip: "Comprehensive and actionable information on how to start selling profitable products on Amazon in less than three months, without the need for your own brand.",
        mark: CHECK_MARK
      },
      tariffs: {
        mark: CHECK_MARK
      }
    },
    {
      title: {
        text: "\"Get Started Your Amazon Business\" Guide",
        tooltip: "This guide will give you step-by-step instructions on how to start selling on Amazon using AMZScout’s powerful seller tools.",
        mark: CHECK_MARK
      },
      tariffs: {
        mark: CHECK_MARK
      }
    },
    {
      title: {
        text: "1-on-1 Mentor Call",
        tooltip: "Get personal guidance during a 30-minute call from proven Amazon six- or seven-figure sellers. Discuss your plan for launch your own business on Amazon or strategize changes for your existing business.",
        mark: {
          monthly: CROSS,
          monthly_3: CROSS,
          yearly: CHECK_MARK
          // lifetime: CHECK_MARK
        }
      },
      tariffs: {
        mark: {
          monthly: CROSS,
          monthly_3: CROSS,
          yearly: CHECK_MARK
          // lifetime: CHECK_MARK
        }
      }
    }
  ]
};
const COMPETITOR_DATA_ANALYSIS = {
  title: "Competitor Data Analysis",
  tab: [
    {
      title: {
        text: "Quick View",
        tooltip: "See instant product sales data as if you were the seller, right on the search results page.",
        mark: CHECK_MARK,
        info: {
          monthly: SEARCHES_MONTH_250,
          monthly_3: SEARCHES_MONTH_250,
          yearly: SEARCHES_MONTH_500
          // lifetime: SEARCHES_MONTH_500
        }
      },
      tariffs: {
        info: {
          monthly: SEARCHES_MONTH_250,
          monthly_3: SEARCHES_MONTH_250,
          yearly: SEARCHES_MONTH_500
          // lifetime: SEARCHES_MONTH_500
        }
      }
    },
    {
      title: {
        text: "Stock Stats",
        tooltip: "Monitor competitors' stock sizes to gauge demand. Sell at a higher price when competitors run out of stock.",
        mark: CHECK_MARK
      },
      tariffs: {
        mark: CHECK_MARK
      }
    }
  ]
};

export const DESCRIPTION = [
  PRODUCT_RESEARCH_TOOLS,
  KEYWORD_RESEARCH_TOOLS,
  TRENDS_AND_PRODUCT_IDEAS_BUNDLE,
  LEARNING,
  COMPETITOR_DATA_ANALYSIS
];
